import IconHoverMessage from "../../images/icon_hover_message.svg";
import { DivLi, LabelStyleText, LabelText } from "./UsersManagementAdminStyles";

const HoverMessage = (props) => {
  return (
    <DivLi>
      <img
        width="25"
        height="25"
        src={props.icon ? props.icon : IconHoverMessage}
        alt=""
      />
      <LabelText
        positions={props.position}
        width={props.width}
        left={props.left}
        leftBefore={props.leftBefore}
        style={{ fontSize: "1.5rem" }}
      >
        <LabelStyleText>{props.children}</LabelStyleText>
      </LabelText>
    </DivLi>
  );
};

export default HoverMessage;
